import Events from '@/lib/events.js'
import config from '@/lib/config.js'

const Logger = {
    log(message, data) {
        if (!config.logging)
            return

        if (typeof message != 'string')
            return                    

        if (data === undefined)
            console.log(message)
        else        
            console.log({
                message: message,
                data: data
            })
    },
    logFunc(className, funcName, data) {
        Logger.log(className + '::' + funcName, data)
    },
    argExpectedType(varName, expTypeName, obj) {
        Logger.log('-- ArgExpectedType: ' + varName + ' is expected to be ' + expTypeName, obj)
    },
    argNull(varName) {
        Logger.log('-- ArgNull: ' + varName)
    },
    registerEventLog(event) {
        if (!config.logging)
            return

        Events.$on(event, data => this.log(event, data))
    },
    registerEventLogging() {
        if (!config.logging)
            return
            
        Events.list.forEach(event => this.registerEventLog(event))
    }
}

export default Logger